// The numbers a guest can call to reach booking staff. One place for the
// pair so no screen carries its own copy. Bare 10-digit Indian mobiles;
// telHref() turns one into the +91 form a tel: link needs.
export const CONTACT_NUMBERS = ['9435558001', '9854958549'];

export const telHref = (number) => `tel:+91${number}`;
